import { createContext, useContext, useEffect, useMemo, useState } from 'react';

const CartCtx = createContext(null);
const KEY = 'locals_cart_v1';

export function CartProvider({ children }) {
    const [items, setItems] = useState(() => {
        try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { return []; }
    });

    useEffect(() => {
        localStorage.setItem(KEY, JSON.stringify(items));
    }, [items]);

    const addItem = (product, variant, qty = 1) => {
        setItems((prev) => {
            const key = `${product.id}::${variant.sku}`;
            const idx = prev.findIndex((i) => i.key === key);
            if (idx >= 0) {
                const next = [...prev];
                next[idx] = { ...next[idx], qty: next[idx].qty + qty };
                return next;
            }
            return [...prev, {
                key, product_id: product.id, sku: variant.sku,
                product_name: product.name, variant_label: variant.label,
                unit_price: product.price, qty,
                image_url: product.image_url, category: product.category,
            }];
        });
    };

    const setQty = (key, qty) => {
        setItems((prev) => prev
            .map((i) => (i.key === key ? { ...i, qty: Math.max(0, qty) } : i))
            .filter((i) => i.qty > 0));
    };

    const remove = (key) => setItems((prev) => prev.filter((i) => i.key !== key));
    const clear = () => setItems([]);

    const subtotal = useMemo(
        () => items.reduce((s, i) => s + i.unit_price * i.qty, 0),
        [items]
    );
    const count = useMemo(() => items.reduce((s, i) => s + i.qty, 0), [items]);

    return (
        <CartCtx.Provider value={{ items, addItem, setQty, remove, clear, subtotal, count }}>
            {children}
        </CartCtx.Provider>
    );
}

export const useCart = () => useContext(CartCtx);
